const convertRuToEn = input => {
	if(!input) return

	const ru = "ёйцукенгшщзхъфывапролджэячсмитьбю.";
	const en = "`qwertyuiop[]asdfghjkl;'zxcvbnm,/.";

	return input
		.split("")
		.map(char => {
			const index = ru.indexOf(char.toLowerCase());
			if (index === -1) return char;

			const newChar = en[index];
			return char === char.toUpperCase()
				? newChar.toUpperCase()
				: newChar;
		})
		.join("");
};

export { convertRuToEn };
